// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"detail_imageContainer__3PrmH","loadingWrap":"detail_loadingWrap__1Ur0h"};